import mitt from 'mitt';
// tslint:disable no-string-literal
/**
 * TODO: A giant hack because of the bizarre
 * Shop-Reboot pubsub implementation that is
 * responsible for emitting wishist and cart
 * updates
 *
 * FIXME: Please, remove this 💩 as soon as
 * possible (have a beer and enjoy yourself
 * if you can remove this FIXME from the code)
 */
var createEmitter = function () {
    var SHOULD_USE_JQ_PUBSUB = typeof $ !== 'undefined' &&
        typeof $['subscribe'] === 'function' &&
        typeof $['publish'] === 'function' &&
        typeof $['unsubscribe'] === 'function';
    if (SHOULD_USE_JQ_PUBSUB) {
        /**
         * INFO: jQuery pubsub implementation has API that is
         * not matching mitt API. To solve this we will proxy
         * publish and subscribe methods from jQ.
         *
         * Overwriting event handlers will cause unsubscribe not
         * working in most cases. To avoid this we will keep
         * wrapped handlers mapped to the original handlers
         * in a Map, which will allow us to unsubscribe from
         * events
         */
        var events_1 = {};
        return {
            on: function (name, handler) {
                if (!events_1[name]) {
                    events_1[name] = new Map();
                }
                var wrappedHandler = function (_, data) { return handler(data); };
                events_1[name].set(handler, wrappedHandler);
                $['subscribe'](name, wrappedHandler);
            },
            off: function (name, handler) {
                if (!events_1[name]) {
                    events_1[name] = new Map();
                }
                var wrappedHandler = events_1[name].get(handler);
                $['unsubscribe'](name, wrappedHandler || handler);
            },
            emit: function (name, data) {
                $['publish'](name, data);
            },
        };
    }
    else {
        return new mitt();
    }
};
/**
 * Returns global context or an empty object
 */
var getContext = function () {
    return typeof window !== 'undefined' && window.window === window
        ? window
        : typeof global !== 'undefined' && global.global === global
            ? global
            : {};
};
/**
 * Creates an instance of event bus with
 * the shared, global emitter
 */
var EventBus = /** @class */ (function () {
    function EventBus() {
        this.context = getContext();
        this.emitter =
            this.context[EventBus.namespace] ||
                (this.context[EventBus.namespace] = createEmitter());
    }
    /**
     * Subscribe handler to the event
     */
    EventBus.prototype.on = function (name, handler) {
        this.emitter.on(name, handler);
    };
    /**
     * Unsubscribe handler from the event
     */
    EventBus.prototype.off = function (name, handler) {
        this.emitter.off(name, handler);
    };
    /**
     * Publish event
     */
    EventBus.prototype.emit = function (name, data) {
        this.emitter.emit(name, data);
    };
    // create namespace in global symbol registry
    EventBus.namespace = Symbol.for('EVENT_BUS_GLOBAL_NAMESPACE');
    return EventBus;
}());
export default EventBus;
